import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    getall () {
        return Api().get('year/getall')
    },


    //GMW
    getallgmw () {
        return GmwApi().get('year/getall')
    },
}